import { alphaSorter } from 'vet-bones/utils';

import { Model } from 'src/containers/ProjectDiagram/types/model';
import { addSensitivePropertyGroup } from 'src/containers/ProjectDiagram/utils/sensitivePropertyGroups/addSensitivePropertyGroup';
import { Database } from 'src/store/state/databases';

export const addSensitivePropertyGroupsFromDatabase =
  (database: Database) => (model: Model) => {
    if (!database || !database.sensitivePropertyGroups) {
      return;
    }

    const { sensitivePropertyGroups } = database;
    const { attributesByIri, sensitivePropertyGroupsByName } = model.modelData;
    const existingAttributeIris = new Set(Object.keys(attributesByIri));
    const usedSpgNames = new Set(Object.keys(sensitivePropertyGroupsByName));

    const getUniqueSpgName = (baseName: string) => {
      if (!usedSpgNames.has(baseName)) {
        return baseName;
      }

      let numberForName = 1;
      let numberedName = `${baseName}_${numberForName}`;
      while (usedSpgNames.has(numberedName)) {
        numberForName += 1;
        numberedName = `${baseName}_${numberForName}`;
      }
      return numberedName;
    };

    Object.entries(sensitivePropertyGroups).forEach(
      ([groupName, attributeIris]) => {
        const uniqueSpgName = getUniqueSpgName(groupName);
        const attributesForSpg: string[] = [];

        attributeIris.sort(alphaSorter).forEach((attributeIri) => {
          if (existingAttributeIris.has(attributeIri)) {
            attributesForSpg.push(attributeIri);
          }
        });

        if (attributesForSpg.length) {
          addSensitivePropertyGroup(uniqueSpgName, attributesForSpg)(model);
        }
      }
    );
  };
